import SystemGaugeChart from "../SystemGaugeChart";

export default function SupportProjectScreenGauges() {
    // Used in

    // BUILD
    return (
        <div className={"mt-[24px] w-full flex justify-around items-center"}>
            <SystemGaugeChart current={1400}
                              total={3500}
                              title={"Questions flash"} />
            <SystemGaugeChart current={10}
                              total={350}
                              title={"Exerciseurs"} />
            <SystemGaugeChart current={0}
                              total={350}
                              title={"Vidéos"} />
        </div>
    );
}